import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const API_URL = `${domain}/api/EmployeeType`;
const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const employeeTypeService = {
  getAll: () => axios.get(API_URL, { headers }),
  getAllActive: async (params = {}) => {
    return await axios.get(`${API_URL}/active`, {
      headers,
      params: params
    });
  },
  create: (data) => axios.post(API_URL, data, { headers }),
  update: (id, data) => axios.put(`${API_URL}/${id}`, data, { headers }),
};

export default employeeTypeService;